<script setup lang="ts">
import { MessageSquare, Settings, User } from 'lucide-vue-next'
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()

withDefaults(
  defineProps<{
    settingActive?: boolean
    showSetting?: boolean
  }>(),
  {
    settingActive: false,
    showSetting: true,
  },
)

const emit = defineEmits<{
  user: []
  feedback: []
  setting: []
}>()
</script>

<template>
  <div class="flex flex-col items-center gap-1">
    <a-tooltip :title="t('shell.account')" placement="right">
      <div
        class="flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 cursor-pointer text-gray-400 dark:text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-800/50 hover:text-gray-600 dark:hover:text-gray-300"
        data-testid="sidebar-user"
        @click="emit('user')"
      >
        <User class="w-5 h-5" aria-hidden="true" />
      </div>
    </a-tooltip>

    <a-tooltip :title="t('shell.feedback')" placement="right">
      <div
        class="flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 cursor-pointer text-gray-400 dark:text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-800/50 hover:text-gray-600 dark:hover:text-gray-300"
        data-testid="sidebar-feedback"
        @click="emit('feedback')"
      >
        <MessageSquare class="w-5 h-5" aria-hidden="true" />
      </div>
    </a-tooltip>

    <a-tooltip v-if="showSetting" :title="t('shell.settings')" placement="right">
      <div
        class="flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 cursor-pointer"
        :class="
          settingActive
            ? 'bg-primary/10 text-primary'
            : 'text-gray-400 dark:text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-800/50 hover:text-gray-600 dark:hover:text-gray-300'
        "
        data-testid="sidebar-setting"
        @click="emit('setting')"
      >
        <Settings class="w-5 h-5" aria-hidden="true" />
      </div>
    </a-tooltip>
  </div>
</template>
